import { cn } from "../../lib/utils.mjs";
import { focusRing } from "../../lib/focus.mjs";
import { glassPanel, glassTile } from "../../lib/glass.mjs";
import * as React from "react";
import { cva } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
import { Slot } from "radix-ui";
//#region src/components/ui/card.tsx
const cardVariants = cva("text-card-foreground", {
	variants: {
		variant: {
			default: "",
			marketing: ""
		},
		floating: {
			true: glassPanel,
			false: glassTile
		},
		interactive: {
			true: cn("transition-[transform,box-shadow] duration-[var(--duration-fast)] ease-[var(--ease-smooth-out)]", "hover:shadow-[0_28px_56px_-20px_color-mix(in_oklab,var(--shadow-ink)_34%,transparent)]", "motion-safe:hover:-translate-y-0.5 motion-safe:focus-visible:-translate-y-0.5 motion-safe:has-[:focus-visible]:-translate-y-0.5", focusRing, "has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-ring has-[:focus-visible]:ring-offset-2 has-[:focus-visible]:ring-offset-background"),
			false: ""
		}
	},
	compoundVariants: [{
		variant: "marketing",
		className: "rounded-lg"
	}],
	defaultVariants: {
		variant: "default",
		floating: false,
		interactive: false
	}
});
const Card = React.forwardRef(function Card({ className, variant, floating, interactive, asChild = false, ...props }, ref) {
	const Comp = asChild ? Slot.Root : "div";
	const floats = floating ?? variant === "marketing";
	return /* @__PURE__ */ jsx(Comp, {
		ref,
		"data-interactive": interactive ? "" : void 0,
		"data-floating": floats ? "" : void 0,
		className: cn(cardVariants({
			variant,
			floating: floats,
			interactive
		}), className),
		...props
	});
});
const CardHeader = React.forwardRef(function CardHeader({ className, ...props }, ref) {
	return /* @__PURE__ */ jsx("div", {
		ref,
		className: cn("flex flex-col space-y-1.5 p-6", className),
		...props
	});
});
const CardTitle = React.forwardRef(function CardTitle({ className, ...props }, ref) {
	return /* @__PURE__ */ jsx("h3", {
		ref,
		className: cn("label-lg font-semibold text-text-heading-1", className),
		...props
	});
});
const CardDescription = React.forwardRef(function CardDescription({ className, ...props }, ref) {
	return /* @__PURE__ */ jsx("p", {
		ref,
		className: cn("body-sm text-text-caption-1", className),
		...props
	});
});
const CardContent = React.forwardRef(function CardContent({ className, ...props }, ref) {
	return /* @__PURE__ */ jsx("div", {
		ref,
		className: cn("p-6 pt-0", className),
		...props
	});
});
const CardFooter = React.forwardRef(function CardFooter({ className, ...props }, ref) {
	return /* @__PURE__ */ jsx("div", {
		ref,
		className: cn("flex items-center p-6 pt-0", className),
		...props
	});
});
//#endregion
export { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, cardVariants };
